"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormModelWalker = void 0;
class FormModelWalker {
    depth;
    _path = [];
    currentTerm;
    currentIterable;
    // Use depth to limit the depth of the walk
    *start(ast, depth) {
        this._path = [];
        this.depth = depth;
        yield* this.walk(ast);
    }
    *walk(ast) {
        const result = yield ast;
        if (result === "no-follow") {
            return;
        }
        if (this.depth && ast.type === this.depth) {
            return;
        }
        switch (ast.type) {
            case "model-root":
                this.open("terms");
                for (const term of Object.values(ast.terms)) {
                    this.open(term.name);
                    this.currentTerm = term;
                    yield* this.walk(term);
                    this.currentTerm = undefined;
                    this.close(term.name);
                }
                this.close("terms");
                this.open("iterables");
                for (const iterable of Object.values(ast.iterables)) {
                    this.open(iterable.name);
                    this.currentIterable = iterable;
                    yield* this.walk(iterable);
                    this.currentIterable = undefined;
                    this.close(iterable.name);
                }
                this.close("iterables");
                break;
            case "iterable":
                this.open("terms");
                for (const term of Object.values(ast.terms)) {
                    this.open(term.name);
                    this.currentTerm = term;
                    yield* this.walk(term);
                    this.currentTerm = undefined;
                    this.close(term.name);
                }
                this.close("terms");
                break;
            case "term":
                this.open("enums");
                for (const [index, enumItem] of ast.enums?.entries() ?? []) {
                    this.open(index);
                    yield* this.walk(enumItem);
                    this.close(index);
                }
                this.close("enums");
                this.open("validationList");
                for (const [index, validation] of ast.validationList?.entries() ?? []) {
                    this.open(index);
                    yield* this.walk(validation);
                    this.close(index);
                }
                this.close("validationList");
                this.open("events");
                for (const [index, event] of ast.events?.entries() ?? []) {
                    this.open(index);
                    yield* this.walk(event);
                    this.close(index);
                }
                this.close("events");
                break;
            case "term-event":
                this.open("statements");
                for (const [index, statement] of ast.statements.entries()) {
                    this.open(index);
                    yield* this.walk(statement);
                    this.close(index);
                }
                this.close("statements");
                break;
            case "term-enum":
            case "term-validation":
            case "term-event-suppose":
            case "term-event-when":
            case "term-event-set":
                break;
            default:
                throw new Error(`Unexpected node type: ${JSON.stringify(ast, null, 2)}`);
        }
    }
    open(path) {
        this._path.push(path);
    }
    close(path) {
        const validatePath = this._path.pop();
        if (validatePath !== path) {
            throw new Error(`Expected to close "${path}" but closed "${validatePath}" instead`);
        }
    }
    get path() {
        return this._path.reduce((acc, path) => {
            if (typeof path === "number") {
                return `${acc}[${path}]`;
            }
            if (acc === "") {
                return String(path);
            }
            return `${acc}.${path}`;
        }, "");
    }
}
exports.FormModelWalker = FormModelWalker;
//# sourceMappingURL=walker.js.map